/*
 * Helpers for Locale translations
 */

import i18next from 'i18next';
import localeData from '../locales.json';

let doSetup = true;

export default class Locale {
    static setup() {
        if (doSetup) {
            doSetup = false;
            const resources = {};
            Object.keys(localeData).forEach(locale => {
                resources[locale] = {
                    translation: {...localeData[locale]} // Use default namespace
                };
            });
            i18next.init({
                lng: 'en-US',
                debug: false,
                resources,
                initImmediate: false,
                interpolation: {prefix: '{', suffix: '}'}
            });
        }
    }

    static exists(locale) {
        Locale.setup();
        return locale in localeData;
    }

    static change(newLocale) {
        if (Locale.exists(newLocale)) {
            Locale.setup();
            i18next.changeLanguage(newLocale);
        }
        return i18next.language;
    }

    static getText(label, options) {
        Locale.setup();
        const rval = i18next.t(label, options);
        if (rval) {
            const isBadActor =
                /<(basefont|input|iframe).*?>|<(applet|form|frameset|iframe|ruby|object|script).*?<\/\2>/i.test(rval);
            if (!isBadActor) {
                const isHTML =
                    /<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/i.test(
                        rval
                    );
                if (isHTML) {
                    // eslint-disable-next-line react/no-danger
                    return <span dangerouslySetInnerHTML={{__html: rval}} />;
                }
            }
        }
        return rval;
    }
}
